import useFootPrintTracker, { FootPrintTracking } from './FootPrintTracking';
export { FootPrintTracking };
export default useFootPrintTracker;
